"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _rowConfig = _interopRequireDefault(require("../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../core/form-group"));
var _col = _interopRequireDefault(require("../../../core/col"));
var _row = _interopRequireDefault(require("../../../core/row"));
var _deleteButton = _interopRequireDefault(require("../../../core/delete-button"));
var _newSpecial = _interopRequireDefault(require("./new-special"));
var _input = _interopRequireDefault(require("../../../core/input"));
var _label = _interopRequireDefault(require("../../../core/label"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("div", {
  className: "card-header"
}, /*#__PURE__*/_react.default.createElement("h5", null, "Specials"));
var _ref2 = /*#__PURE__*/_react.default.createElement("div", {
  className: "card-block"
}, "Click day to add a \"special\" (eg Championships or Panceltic) ");
class Specials extends _react.Component {
  render() {
    const application = this.props.application;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref, _ref2, application.competitionDates.map((date, i) => /*#__PURE__*/_react.default.createElement("div", {
      key: i,
      className: "card-block",
      style: {
        borderTop: '1px solid rgba(0,0,0,0.125)'
      }
    }, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: 2
    }, /*#__PURE__*/_react.default.createElement(_newSpecial.default, {
      calendarID: application.calendarID,
      calendarDateID: date,
      dayNumber: i,
      applicationID: application.id
    })), /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: 10
    }, /*#__PURE__*/_react.default.createElement(_row.default, null, application.applicationSpecials.filter(s => s.calendarDateID === date).map(spec => /*#__PURE__*/_react.default.createElement(_formGroup.default, {
      key: spec.id
    }, /*#__PURE__*/_react.default.createElement(_col.default, {
      xs: this.props.userIsCalendarOfficer ? 6 : 10
    }, spec.specialLabel), !this.props.userIsCalendarOfficer ? null : /*#__PURE__*/_react.default.createElement(_col.default, {
      xs: 4
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      name: "useInSubtitle",
      label: "In Subtitle",
      checked: spec.useInSubtitle,
      onChange: value => this.props.setValue(spec.id, value, 'useInSubtitle')
    })), /*#__PURE__*/_react.default.createElement(_col.default, {
      xs: 2
    }, /*#__PURE__*/_react.default.createElement(_deleteButton.default, {
      size: "sm",
      onClick: () => this.props.onDelete(spec.id)
    })))))))))));
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(Specials, "partialQueries", {
  Application: {
    id: true,
    competitionDates: true,
    calendarID: true,
    applicationSpecials: {
      id: true,
      specialLabel: true,
      calendarDateID: true,
      useInSubtitle: true
    }
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(Specials, undefined, (client, props) => ({
  onDelete(applicationSpecialID) {
    return client.update('ApplicationSpecial.delete', {
      applicationSpecialID
    });
  },
  setValue(id, value, field) {
    return client.update('ApplicationSpecial.set', {
      id,
      value,
      field
    });
  }
}));